export enum BedRoomSizeName {
    NORMAL_BED = 'normal-bed',
    BIG_BED = 'big-bed',
    CRIB_BED = 'crib-bed',
    BUNK_BED = 'bunk-bed',
    SOFA_BED = 'sofa-bed',
}
